/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "36eca5a86a9ad726d22620884689535df056e7d3";
